"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _handlebars = _interopRequireDefault(require("handlebars"));

var _underscore = _interopRequireDefault(require("underscore"));

var _backbone = _interopRequireDefault(require("backbone"));

var _socialShareButtons = _interopRequireDefault(require("hbars!../../scripts/templates/social-share-buttons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_handlebars.default.registerPartial('social-share-buttons', _socialShareButtons.default);

var SocialButtonsView = _backbone.default.View.extend({
  events: {
    'click .js-social-share-link': 'socialShareClicked'
  },
  socialShareClicked: function socialShareClicked(e) {
    e.preventDefault();
    var isWebsiteTemplate = (0, _jquery.default)(e.currentTarget).attr('data-isWebsiteTemplate');
    if (isWebsiteTemplate) return;
    var href = (0, _jquery.default)(e.currentTarget).attr('data-href');
    window.open(href, '_blank', 'height=500,width=500');
  }
});

var _default = SocialButtonsView;
exports.default = _default;